import React from 'react';
import { UserCircleIcon, ClipboardCheckIcon, FlaskConicalIcon, HeartPulseIcon } from 'lucide-react';
export function ProcessSection() {
  const steps = [{
    number: '1',
    icon: <UserCircleIcon className="text-white" size={32} data-id="element-575" />,
    title: 'Initial Consultation',
    description: 'Your dedicated IVF coordinator arranges a consultation with a specialist doctor who reviews your medical history, performs necessary tests, and discusses your goals and concerns.',
    color: 'from-blue-600 to-blue-700'
  }, {
    number: '2',
    icon: <ClipboardCheckIcon className="text-white" size={32} data-id="element-576" />,
    title: 'Treatment Planning',
    description: 'Based on your consultation results, the doctor recommends a personalized treatment plan tailored to your specific needs, which begins after your approval.',
    color: 'from-cyan-600 to-cyan-700'
  }, {
    number: '3',
    icon: <FlaskConicalIcon className="text-white" size={32} data-id="element-577" />,
    title: 'Egg Retrieval & Transfer',
    description: 'Following hormonal stimulation, eggs are retrieved and fertilized in our advanced laboratory. Embryos are carefully monitored for several days before transfer to the uterus.',
    color: 'from-blue-500 to-blue-600'
  }, {
    number: '4',
    icon: <HeartPulseIcon className="text-white" size={32} data-id="element-578" />,
    title: 'Pregnancy Confirmation',
    description: 'A pregnancy test can be taken just 14 days after embryo transfer to confirm if the treatment has been successful.',
    color: 'from-cyan-500 to-cyan-600'
  }];
  return <section className="py-20 bg-gradient-to-b from-white to-slate-50" data-id="element-579">
      <div className="container mx-auto px-4" data-id="element-580">
        <div className="text-center mb-16" data-id="element-581">
          <div className="inline-block bg-blue-50 rounded-full px-4 py-2 mb-4" data-id="element-582">
            <span className="text-blue-700 font-semibold text-sm tracking-wide uppercase" data-id="element-583">
              The IVF Process
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 tracking-normal" data-id="element-584">
            Your Journey{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-600 px-1 py-1 inline-block" data-id="element-585">
              Step by Step
            </span>
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg font-light leading-relaxed" data-id="element-586">
            Understanding the IVF process helps you feel prepared and confident.
            Here's what to expect at each stage of your treatment.
          </p>
        </div>
        <div className="max-w-5xl mx-auto" data-id="element-587">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-588">
            {steps.map((step, index) => <div key={index} className="relative bg-white border border-slate-100 rounded-3xl p-8 hover:shadow-xl transition-all duration-300 group" data-id="element-589">
                <div className="flex items-start gap-6" data-id="element-590">
                  <div className="relative flex-shrink-0" data-id="element-591">
                    <div className={`bg-gradient-to-br ${step.color} p-4 rounded-2xl group-hover:scale-110 transition-transform shadow-lg`} data-id="element-592">
                      {step.icon}
                    </div>
                    <div className={`absolute -top-2 -right-2 bg-gradient-to-br ${step.color} text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm shadow-lg`} data-id="element-593">
                      {step.number}
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-594">
                    <h3 className="text-xl font-bold text-slate-900 mb-3 tracking-normal" data-id="element-595">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed font-light" data-id="element-596">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="mt-12 bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-3xl p-8 text-center" data-id="element-597">
            <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-598">
              Questions About the Process?
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-599">
              Our team is here to guide you through every step and answer any
              questions you may have about your fertility journey.
            </p>
            <a href="/contact" className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-blue-600/30 hover:scale-105 font-medium" data-id="element-600">
              Schedule a Consultation
            </a>
          </div>
        </div>
      </div>
    </section>;
}